import { render, staticRenderFns } from "./WordsFieldPreview.vue?vue&type=template&id=314b2847&lang=pug&"
import script from "./WordsFieldPreview.vue?vue&type=script&lang=js&"
export * from "./WordsFieldPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports